import FileUploadModel from '@/components/FileUploadModel'
import ExportModel from '@/components/ExportModel'
import ProgressModal from '@/components/ProgressModal'

export default function registerComponents(app) {
  app.component('FileUploadModel', FileUploadModel)
  app.component('ExportModel', ExportModel)
  app.component('ProgressModal', ProgressModal)
}
